import { useStreamInvalidation } from '../../../../view-system/hooks/useStreamInvalidation';
import { FLOW_NOTES_KEY, FLOW_NOTES_SUMMARIES_KEY } from './notes-query-keys';

const NOTES_KEYS = [FLOW_NOTES_KEY, FLOW_NOTES_SUMMARIES_KEY] as const;

/**
 * Keeps Notes caches fresh from the shared app-home SSE stream: every
 * `flow:notes:changed` frame, and every reconnect (the server does not replay
 * frames), invalidates both bare prefixes.
 *
 * Subscribes to the same stream key `useV4InvalidateOnStream` uses, so no
 * second EventSource is opened.
 */
export function useFlowNotesLive(): void {
  useStreamInvalidation({
    when: (event) => event.type === 'flow:notes:changed',
    keys: NOTES_KEYS,
  });
}
